import React, { useEffect, useContext, useState, useCallback, useRef } from 'react'
import { FormContainer } from '../../uiwidgets/FormContainer';
import { FormField } from '../../uiwidgets/FormField';
import ProvinceSelect from 'uiwidgets/ProvinceSelect';
import PostalCode from 'uiwidgets/PostalCode';
import CountrySelect from 'uiwidgets/CountrySelect';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { CancelButton } from '../../uiwidgets/CancelButton';
import { Row, Col, Table, Button, Image } from 'react-bootstrap';
import { TenantContext } from '../../tenant/TenantContext';
import { SecurityContext } from 'security/SecurityContext';
import { evenRound } from '../../util/NumberUtils';
import useExternalScripts from 'util/useExternalScripts';
import { API } from 'api/API';
import {
    PROFILE_URL, BUSINESS_DONATION_CAUSES, RECURRINGPAYMENTS_URL, BUSINESS_ACCOUNT_TYPES_URL,
    BUSINESS_DONATION_CAUSES_URL, PAYMENT_CARDS, USER_EMAIL_ADDRESS_EXISTS, BUSINESS_ACCOUNTS_URL,
    BUSINESS_USER_ACCOUNTS_URL
} from 'config/config';
import { extractError } from 'api/ErrorUtil';
import { formatCurrency } from 'util/Currency';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
    isEmailAddressValid, isPostalCodeValid,
    isPhoneValid, isNumeric, containsAlphabetsOnly,
    isValidDate, isDateGreaterThanToday, containsAlphaNumOnly,
    isValidUUID, containsAlphaNumAndSpaceOnly
} from "util/Validators";
import _ from "lodash";
import { formatDate, stringDateToUTC, stringUTCToLocal } from 'util/Date';
import { validAddress } from 'util/Validators';
import { openLightbox } from 'util/ElavonLightBox';
import AppSpinner from 'uiwidgets/AppSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import StripeElements from 'util/StripeElements';

const RecurringPaymentPage = () => {
    const { businessConfig } = useContext(TenantContext);
    useExternalScripts(businessConfig.elavonLightboxUrl);
    const [formData, setFormData] = useState({
        country: "CA", state: "ON", donationLineItems: [], totalAmount: null,
        currentDonationCause: "", currentDonationCauseValue: "0.00", recPayment: null,
        editMode: false, account: {}, accountType: {}, accountTypeId: "", billPaymentAmount: "0.00",
        payFullAmount: false, isBill: false, paymentFreq: 'MONTHLY', receiptInCompanyName: false,
        paymentCards: [], paymentCardId: "", userAccounts: []
    });
    const [formValidityData, setFormValidityData] = useState({});

    const [selectedCauseAttributes, setSelectedCauseAttributes] = useState([]);
    const [hasDescription, setHasDescription] = useState(false);
    const [mediaType, setMediaType] = useState("");
    const secCtx = useContext(SecurityContext);
    const navigate = useNavigate();
    const causeAmountFieldRef = useRef(null);
    const requestParams = useParams();
    const location = useLocation();
    const paymentGateway = businessConfig.paymentGateway;
    const saveCardFunction = useRef(null);

    const messageReset = () => {
        return {
            infoMessage: "",
            errors: {}
        }
    }
    const onToastClose = () => {
        setFormData({
            ...formData,
            ...messageReset()
        });
    }

    const getPaymentCards = async (email) => {
        try {

            let paymentCards = [];
            if (secCtx.profile.roles.includes("ROLE_CONSUMER")) {
                paymentCards = await API.get(PAYMENT_CARDS);
            } else if (secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
                paymentCards = await API.get(PAYMENT_CARDS + '/' + email);
            } else {
                return paymentCards;
            }
            return paymentCards.data
        } catch (err) {
            let errors = extractError(err);
            if (errors.httpStatus !== 404) {
                setFormData({ ...formData, errors: errors });
                return;
            }
        };
    };

    const getUserProfile = async (email) => {
        try {
            let profileResp = {};
            if (secCtx.profile.roles.includes("ROLE_CONSUMER")) {
                profileResp = await API.get(PROFILE_URL);
            } else if (secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
                let emailExistsUrl = USER_EMAIL_ADDRESS_EXISTS.replace('${userEmailAddress}', email);
                profileResp = await API.get(emailExistsUrl);
            } else {
                return profileResp;
            }
            return profileResp.data;

        } catch (err) {
            let errors = extractError(err);
            if (errors.httpStatus !== 404) {
                setFormData({ ...formData, errors: errors });
                return null;
            } else {
                setFormData({ ...formData, errors: { message: "Email was not found. Recurring payment for this email cannot be created" } });
                return null;
            }
        };
    }

    async function listAccountTypesForAdmin() {
        let response = await API.get(BUSINESS_ACCOUNT_TYPES_URL)
        return response.data;
    }

    const getAccountByIdForAdmin = async (accountId) => {
        let response = API.get(BUSINESS_ACCOUNTS_URL + '/' + accountId);
        return (await response).data;
    }

    const getAccountAndTypeForAdminDirect = async (accountId) => {
        let accountTypes = null;
        let account = null;
        try {
            accountTypes = await listAccountTypesForAdmin();
            account = await getAccountByIdForAdmin(accountId);
            let filteredAccountTypes = accountTypes.filter(accountType => accountType.id === account.accountTypeId)
            let accountType = filteredAccountTypes[0];
            return { accountType, account };

        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {

            } else {
                setFormData({
                    ...formData,
                    errors: { message, errors, httpStatus },

                });
            }
            return;
        }
    }
    const getAccountAndTypeForAdmin = (accountId, accounts) => {
        let userAccounts = formData.userAccounts;
        if (_.isEmpty(userAccounts)) {
            if (_.isEmpty(accounts)) {
                alert("Could not find User Accounts");
            } else {
                userAccounts = accounts;
            }
        }

        let filteredAccounts = userAccounts.filter(account => account.id === accountId)
        let account = filteredAccounts[0];

        let filteredAccountTypes = businessConfig.accountTypes.filter(accountType => accountType.id === account.accountTypeId)
        let accountType = filteredAccountTypes[0];

        return { accountType, account };
    }

    const getAccountAndTypeForConsumer = (accountId) => {
        let filteredAccounts = secCtx.accounts.filter(account => account.id === accountId)
        let account = filteredAccounts[0];

        let filteredAccountTypes = businessConfig.accountTypes.filter(accountType => accountType.id === account.accountTypeId)
        let accountType = filteredAccountTypes[0];

        return { accountType, account };
    }

    const getAccountAndType = (accountId) => {
        if (secCtx.profile.roles.includes("ROLE_CONSUMER")) {
            return getAccountAndTypeForConsumer(accountId);
        } else if (secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
            return getAccountAndTypeForAdmin(accountId);
        } else {
            return null;
        }
    }

    const getAccountAndTypeByTypeForAdmin = (accType) => {
        if (_.isEmpty(formData.userAccounts)) {
            //alert("Could not find user accounts");
            return;
        }

        let filteredAccountTypes = businessConfig.accountTypes.filter(accountType => accountType.accountType === accType)
        let accountType = filteredAccountTypes[0];

        let filteredAccounts = formData.userAccounts.filter(account => account.accountTypeId === accountType.id)
        let account = filteredAccounts[0];

        return { accountType, account };
    }

    const getAccountAndTypeByTypeForConsumer = (accType) => {

        let filteredAccountTypes = businessConfig.accountTypes.filter(accountType => accountType.accountType === accType)
        let accountType = filteredAccountTypes[0];

        let filteredAccounts = secCtx.accounts.filter(account => account.accountTypeId === accountType.id)
        let account = filteredAccounts[0];

        return { accountType, account };
    }

    const getAccountAndTypeByType = (accountType) => {
        if (secCtx.profile.roles.includes("ROLE_CONSUMER")) {
            return getAccountAndTypeByTypeForConsumer(accountType);
        } else if (secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
            return getAccountAndTypeByTypeForAdmin(accountType);
        } else {
            return null;
        }
    }

    const getAccountsForAdmin = async (email) => {
        let userAccounts = [];
        try {

            if (secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
                let userAccountsResp = await API.get(BUSINESS_USER_ACCOUNTS_URL + '/' + email);
                userAccounts = userAccountsResp.data
                return userAccounts;
            }
        } catch (err) {
            let errors = extractError(err);
            if (errors.httpStatus !== 404) {
                setFormData({ ...formData, errors: errors });
                return;
            }
        };
        return userAccounts;
    }

    const fetchProfileAndDonationCauses = useCallback(async () => {
        try {
            let recPayment = {};
            let profile = {};
            let editMode = false;
            let savedDonationCause = "";
            let savedDonationCauseValue = 0.00;
            let savedTotalAmount = 0.00;
            let sponsorshipCause = false;
            let isBill = false;
            let payFullAmount = false;
            let paymentCards = [];
            let localFormData = { ...formData };

            if (requestParams.recpmtid) {
                editMode = true;
                //fetch recurring payment records
                recPayment = location.state.recPmtSpec;
                profile = recPayment.payer;
                savedTotalAmount = evenRound(parseFloat(recPayment.paymentAmount) / 100, 2);
                payFullAmount = recPayment.payFullAmount;
                paymentCards = await getPaymentCards(profile.email);
                let userAccounts = await getAccountsForAdmin(profile.email);
                let account = null;
                let accountType = null;
                if (_.isEmpty(formData.userAccounts) && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
                    let accAndType = getAccountAndTypeForAdmin(recPayment.accountId, userAccounts);
                    account = accAndType.account;
                    accountType = accAndType.accountType;
                } else {
                    let accAndType = getAccountAndType(recPayment.accountId);
                    account = accAndType.account;
                    accountType = accAndType.accountType;
                }

                if (accountType.accountType === 'DONATION') {
                    isBill = false;
                } else {
                    isBill = true;
                }
                localFormData = {
                    ...localFormData,
                    ...profile,
                    paymentFreq: recPayment.paymentFrequency,
                    totalAmount: savedTotalAmount,
                    editMode: editMode,
                    nextPaymentDate: formatDate(stringUTCToLocal(recPayment.nextPaymentDate)),
                    paymentFreq: recPayment.paymentFrequency,
                    recPayment: recPayment,
                    accountType: accountType,
                    account: account,
                    accountTypeId: accountType.id,
                    isBill: isBill,
                    billPaymentAmount: savedTotalAmount,
                    payFullAmount: payFullAmount,
                    receiptInCompanyName: recPayment.receiptInCompanyName,
                    paymentCards: paymentCards,
                    userAccounts: userAccounts
                }
            } else {
                //if billing is not available then make donations as the default account
                if (!businessConfig.appFeatures.includes('BILLING')) {
                    let donAccDetails = getAccountAndTypeByType('DONATION');
                    if (secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")) {
                        localFormData = {
                            ...localFormData,
                            accountType: donAccDetails.accountType,
                            account: donAccDetails.account,
                            accountTypeId: donAccDetails.accountType.id,
                            isBill: false,
                            payFullAmount: false
                        }
                    } else if (secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
                        localFormData = {
                            ...localFormData,
                            isBill: false,
                            payFullAmount: false
                        }
                    }
                }
                if (secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")) {
                    paymentCards = await getPaymentCards(profile.email);
                    profile = await getUserProfile();
                    localFormData = {
                        ...localFormData,
                        ...profile,
                        paymentCards: paymentCards
                    }
                }
            }

            if (businessConfig.appFeatures.includes('DONATION_MANAGEMENT')) {
                //for edit mode we want to get the sponsorship cause as well but not all sponsorships
                let donationCausesUrl = BUSINESS_DONATION_CAUSES
                if (!editMode) {
                    donationCausesUrl = BUSINESS_DONATION_CAUSES + '?nonSponsorshipOnly=true';
                }
                let donationCauseResp = await API.get(donationCausesUrl);
                let donationCauses = donationCauseResp.data;
                let lineItems = [];
                let valLineItems = [];
                for (let i = 0; i < donationCauses.length; i++) {
                    let recurringPaymentSpecDetailId = "";
                    if (editMode) {
                        let recurringPaymentSpecDetail = recPayment.recurringPaymentSpecDetail.filter(rpsd => rpsd.causeId === donationCauses[i].id);
                        if (recurringPaymentSpecDetail && recurringPaymentSpecDetail.length > 0) {
                            recurringPaymentSpecDetailId = recurringPaymentSpecDetail[0].recurringPaymentSpecDetailId
                        }
                    }
                    lineItems[i] = {
                        causeId: donationCauses[i].id,
                        causeCode: donationCauses[i].donationCauseCode,
                        causeAmount: "0.00",
                        lineItemDescription: donationCauses[i].donationCauseDescription,
                        donationCauseAttributes: donationCauses[i].donationCauseAttributes,
                        mediaType: donationCauses[i].mediaType,
                        recurringPaymentSpecDetailId: recurringPaymentSpecDetailId,
                        sponsorshipCause: donationCauses[i].sponsorshipCause
                    };
                    valLineItems[i] = {
                        donationLineItemError: false,
                        donationLineItemErrMsg: ""
                    };
                }
                if (editMode && !isBill) {
                    if (recPayment?.recurringPaymentSpecDetail.length > 0) {
                        savedDonationCause = recPayment.recurringPaymentSpecDetail[0].causeId;
                        //savedDonationCauseValue = evenRound(parseFloat(recPayment.recurringPaymentSpecDetail[0].causeAmount) / 100, 2);
                        savedDonationCauseValue = savedTotalAmount;
                        sponsorshipCause = (!recPayment.recurringPaymentSpecDetail[0].sponsorshipId) ? false : true;
                        localFormData = ({
                            ...localFormData,
                            donationCauses: donationCauses, donationLineItems: lineItems,
                            currentDonationCause: savedDonationCause, currentDonationCauseValue: savedDonationCauseValue,
                            sponsorshipCause: sponsorshipCause
                        });
                    }
                } else {
                    localFormData = ({
                        ...localFormData,
                        donationCauses: donationCauses, donationLineItems: lineItems, totalAmount: null,
                        sponsorshipCause: false
                    });
                }
                setFormValidityData({ donationLineItems: valLineItems });
            }

            setFormData({
                ...formData,
                ...localFormData
            })
        } catch (error) {
            let exError = extractError(error);
            setFormData({
                ...formData,
                errors: exError
            });
        }
    });

    useEffect(() => {
        fetchProfileAndDonationCauses();
    }, []);


    const handleEmailValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        if (!hasError && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
            //get the profile and the parment cards
            let profile = await getUserProfile(value);
            if (_.isEmpty(profile)) {
                setFormValidityData({
                    ...formValidityData,
                    [name + 'Error']: true,
                    [name + 'ErrMsg']: "Invalid email. This email does not exist in the system."
                });
                return;
            }

            let paymentCards = await getPaymentCards(value);
            let accounts = await getAccountsForAdmin(value);

            if (accounts.length > 1) {
                setFormData({
                    ...formData,
                    paymentCards: paymentCards,
                    userAccounts: accounts,
                    ...profile
                })
            } else {
                let accDetails = getAccountAndTypeForAdmin(accounts[0].id, accounts);
                setFormData({
                    ...formData,
                    paymentCards: paymentCards,
                    userAccounts: accounts,
                    accountType: accDetails.accountType,
                    account: accDetails.account,
                    accountTypeId: accDetails.accountType.id,
                    ...profile
                })


            }
        }
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const handleFormDataChange = async (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleCountryChange = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let defaultState = "ON";
        if (value === "US") {
            defaultState = "MI";
        }
        setFormData({
            ...formData,
            [name]: value,
            state: defaultState
        });
    }

    const selectDonationCause = (donationCauseId) => {
        for (let donationLineItem of formData.donationLineItems) {
            if (donationLineItem.causeId === donationCauseId) {
                let hasDesc = donationLineItem.donationCauseAttributes && donationLineItem.donationCauseAttributes.filter(sa => !_.isEmpty(sa.description)).length > 0;
                setMediaType(donationLineItem.mediaType);
                setHasDescription(hasDesc);
                setSelectedCauseAttributes(donationLineItem.donationCauseAttributes);
            }
        }
    }

    const handleDonationCauseChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        selectDonationCause(value);
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleCancel = async (event) => {
        event.preventDefault();
        navigate(-1);
    }

    const handleValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const validateInput = (name, value) => {
        let hasError = false,
            error = ""
        switch (name) {
            case "firstName":
                if (value.trim() === "") {
                    hasError = true
                    error = "First name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid First Name. Only alphbest are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "lastName":
                if (value.trim() === "") {
                    hasError = true
                    error = "Last name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Last Name. Only alphbest are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "address":
                if (value.trim() === "") {
                    hasError = true
                    error = "Address name cannot be empty"
                } else if (!validAddress(value)) {
                    hasError = true
                    error = "Invalid Address. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "city":
                if (value.trim() === "") {
                    hasError = true
                    error = "City name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid First Name. Only alphbest are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "state":
                if (value.trim() === "") {
                    hasError = true
                    error = "State name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid State. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "country":
                if (value.trim() === "") {
                    hasError = true
                    error = "Country name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Country. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "email":
                if (value.trim() === "") {
                    hasError = true
                    error = "Email cannot be empty"
                } else if (!isEmailAddressValid(value)) {
                    hasError = true
                    error = "Invalid Email"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "mobilePhoneNumber":
                if (value.trim() === "") {
                    hasError = true
                    error = "Mobile cannot be empty"
                } else if (!isPhoneValid(value)) {
                    hasError = true
                    error = "Invalid Mobile Number. Use 10 digits only"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "officePhoneNumber":
                if (value.trim() === "") {
                    hasError = false;
                    error = "";
                } else if (!isPhoneValid(value)) {
                    hasError = true
                    error = "Invalid Office Number. Use 10 digits only"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "zip":
                if (value.trim() === "") {
                    hasError = true
                    error = "Postal Code cannot be empty"
                } else if (!isPostalCodeValid(value, formData.country)) {
                    hasError = true
                    error = "Invalid Postal Code"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "donationLineItems":
                if (!isNumeric(value)) {
                    hasError = true
                    error = "Payment Amount must be numeric"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "paymentFreq":
                if (value.trim() === "") {
                    hasError = true
                    error = "Payment Frequency is invalid"
                } else if (!containsAlphaNumOnly(value)) {
                    hasError = true
                    error = "Payment Frequency is invalid"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "nextPaymentDate":
                if (value.trim() === "") {
                    hasError = true
                    error = "Next Payment Date is invalid"
                } else if (!isValidDate(value)) {
                    hasError = true
                    error = "Next Payment Date is invalid"
                } else if (!isDateGreaterThanToday(value)) {
                    hasError = true
                    error = "Next Payment Date must be greater than today's date"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "currentDonationCause":
                if (!value) {
                    hasError = true;
                    error = "Donation Cause is required. Please select one."
                } else if (!isValidUUID(value)) {
                    hasError = true;
                    error = "Donation cause is invalid."

                } else {
                    hasError = false
                    error = ""
                }
                break
            case "currentDonationCauseValue":
                if (!value) {
                    hasError = true;
                    error = "Donation Amount is required."
                } else if (!isNumeric(value) || parseFloat(value) <= 0.00) {
                    hasError = true;
                    error = "Donation Amount is invalid."

                } else {
                    hasError = false
                    error = ""
                }
                break
            case "billPaymentAmount":
                if (formData.payFullAmount) {
                    hasError = false;
                    error = ""
                } else if (!value) {
                    hasError = true;
                    error = "Bill Payment Amount is required."
                } else if (!isNumeric(value) || parseFloat(value) <= 0.00) {
                    hasError = true;
                    error = "Bill Payment Amount is invalid."

                } else {
                    hasError = false
                    error = ""
                }
                break
            case "accountTypeId":
                if (!value) {
                    hasError = true;
                    error = "select an account"
                } else if (!isValidUUID(value)) {
                    hasError = true;
                    error = "account is invalid"

                } else {
                    hasError = false
                    error = ""
                }
                break
            default:
                break
        }
        return { hasError, error }
    }

    const handlePaymentResult = async ({ paymentStatus, errors, response, cardTokenId }) => {
        if (paymentStatus !== 'SUCCEEDED') {
            setFormData({
                ...formData,
                errors: errors,
                processing: false
            })
            return false;
        }

        let dliList = [];
        let totalAmount = 0.00;
        if (!formData.isBill) {
            for (let donationLineItem of formData.donationLineItems) {
                if (donationLineItem.causeId === formData.currentDonationCause) {
                    let dliClone = _.cloneDeep(donationLineItem);
                    dliClone.causeAmount = Math.trunc(evenRound(parseFloat(formData.currentDonationCauseValue) * 100));
                    dliList.push(dliClone)
                    totalAmount = evenRound(totalAmount + parseFloat(dliClone.causeAmount), 2);
                }
            }
        } else {
            totalAmount = Math.trunc(evenRound(parseFloat(formData.billPaymentAmount) * 100));
        }

        const recurringPaymentSpec = {
            nextPaymentDate: formData.nextPaymentDate ? stringDateToUTC(formData.nextPaymentDate) : null,
            payFullAmount: formData.payFullAmount,
            paymentFrequency: formData.paymentFreq,
            gwCardTokenResponse: response,
            accountId: formData.account.id,
            recurringPaymentSpecDetail: dliList,
            customerConsentsToPayPfFees: formData.customerConsentsToPayPfFees,
            paymentAmount: totalAmount,
            receiptInCompanyName: formData.receiptInCompanyName,
            paymentCardId: formData.paymentCardId,
            payer: {
                email: formData.email,
                firstName: formData.firstName,
                lastName: formData.lastName,
                address: formData.address,
                city: formData.city,
                state: formData.state,
                zip: formData.zip,
                country: formData.country,
                mobilePhoneNumber: formData.mobilePhoneNumber
            }
        }
        try {
            let recResp = null;
            if (formData.editMode) {
                recResp = await API.put(RECURRINGPAYMENTS_URL + "/" + formData.recPayment.id, recurringPaymentSpec);
            } else {
                recResp = await API.post(RECURRINGPAYMENTS_URL, recurringPaymentSpec);
            }
            setFormData({
                ...formData,
                readOnly: true,
                processing: false,
                errors: {},
                infoMessage: 'Recurring Payment was added successfully. Click on the "Return to List Page".'
            });
        } catch (error) {
            let errors = extractError(error);
            setFormData({
                ...formData,
                processing: false,
                errors: errors
            });
            return false;
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        let isFormValid = true;
        const tagNames = ['select', 'input', 'textarea'];
        console.log(formData);

        for (let tagName of tagNames) {
            //validate full form
            for (let i = 0; i < event.target.getElementsByTagName(tagName).length; i++) {
                let fieldName = event.target.getElementsByTagName(tagName)[i].name;
                let fieldValue = event.target.getElementsByTagName(tagName)[i].value;
                let { hasError, error } = validateInput(fieldName, fieldValue);
                setFormValidityData({
                    ...formValidityData,
                    [fieldName + 'Error']: hasError,
                    [fieldName + 'ErrMsg']: error
                })
                if (hasError) {
                    isFormValid = false;
                    alert("Form has validation error")
                    return false;
                }
            }
        }

        if (!isFormValid) {
            alert("The form still has validation errors!");
            return false;
        }
        setFormData({ ...formData, readOnly: true, processing: true });

        if (_.isEmpty(formData.paymentCardId)) {
            if (paymentGateway === 'ELAVON') {
                //if every thing works open light box to collect card data
                openLightbox({
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    email: formData.email,
                    mobilePhoneNumber: formData.mobilePhoneNumber,
                    address: formData.address,
                    city: formData.city,
                    state: formData.state,
                    zip: formData.zip
                }, handlePaymentResult);
            } else {
                const status = await saveCardFunction.current();
            }
        } else {
            handlePaymentResult({ paymentStatus: 'SUCCEEDED' });
        }

    }

    const fillAmount = (event, donationAmount, causeAttrDescription) => {
        causeAmountFieldRef.current.focus();
        setFormData({
            ...formData,
            currentDonationCauseValue: donationAmount,
            causeAttrDescription: causeAttrDescription
        });
    }

    const handleAccountTypeChange = (event) => {
        const accountTypeId = event.target.value;
        if (_.isEmpty(accountTypeId)) {
            setFormData({
                ...formData,
                totalAmount: null,
                currentDonationCause: "",
                currentDonationCauseValue: "0.00",
                account: {},
                accountType: {},
                accountTypeId: "",
                billPaymentAmount: "0.00",
                payFullAmount: false, isBill: false, paymentFreq: 'MONTHLY'
            });
            setMediaType("");
            setSelectedCauseAttributes([]);
            return;
        }
        let filteredAccountTypes = {};
        let filteredAccounts = {};
        if (secCtx.profile.roles.includes("ROLE_CONSUMER")) {
            filteredAccountTypes = businessConfig.accountTypes.filter(accountType => accountType.id === accountTypeId)
            filteredAccounts = secCtx.accounts.filter(account => account.accountTypeId === accountTypeId)
        } else if (secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN") && formData.userAccounts) {
            filteredAccountTypes = businessConfig.accountTypes.filter(accountType => accountType.id === accountTypeId)
            filteredAccounts = formData.userAccounts.filter(account => account.accountTypeId === accountTypeId)
        }
        //get account type name
        //if donation then 
        if (_.isEmpty(filteredAccounts)) {
            alert("Unable to find user accounts");
            return false;
        }
        let account = filteredAccounts[0];
        let accountType = filteredAccountTypes[0];
        let payFullAmount = true;
        let isBill = true;
        if (accountType.accountType === 'DONATION') {
            isBill = false;
            payFullAmount = false;
        }
        setFormData({
            ...formData,
            accountTypeId: accountTypeId,
            accountType: accountType,
            account: account,
            isBill: isBill,
            payFullAmount: payFullAmount
        });
    }

    return (
        <>
            {formData.processing && <AppSpinner style={{ marginBottom: 27 }} animation="border" variant="success" />}
            <FormContainer title="Recurring Payments" submitButtonFunction={handleSubmit}
                errors={formData.errors} infoMessage={formData.infoMessage} toastCloseFunc={onToastClose}>
                <Row><Col>Please verify that the information given in the section labeled "Payment Card address verrification" corresponds to your payment card billing address. It is used for card verification.
                    It will be used to verify the payment card. When you click "Add Card Information and Save Schedule", a popup will request card information. Please enter card infomration that will be used to make the scheduled payments and press submit.
                    A payment will <b>not </b>be made at this time. This will schedule a payment to be made on the next payment date.
                </Col></Row>
                <Row><Col>&nbsp;</Col></Row>
                {(businessConfig.appFeatures.includes('BILLING')) && <React.Fragment>
                    <Row>
                        <Col sm={6} md={4} lg={4}>
                            <FormField label="Select Account" type="select" name="accountTypeId" value={formData.accountTypeId || ""}
                                onChange={handleAccountTypeChange} readOnly={formData.editMode} onBlur={handleValidation}
                                valstate={!formValidityData.accountTypeIdError} valMsg={formValidityData.accountTypeIdErrMsg}>
                                <option value="">Select Account</option>
                                {businessConfig.accountTypes.map((type, idx) => (
                                    <option value={type.id} key={idx}>
                                        {type.accountTypeDisplayName}
                                    </option>
                                ))}
                            </FormField>
                        </Col>
                        {formData?.accountType && !_.isEmpty(formData.accountType.accountType) && formData.accountType.accountType !== 'DONATION' && <Col sm={6} md={3} lg={3} >
                            <Table><tbody>
                                <tr>
                                    <td style={{ borderStyle: 'none' }} width="35px">
                                        <br /><FormField
                                            name="payFullAmount"
                                            type="checkbox"
                                            checktype="checkbox"
                                            disabled={formData.readOnly}
                                            value={formData.payFullAmount}
                                            checked={formData.payFullAmount}
                                            onChange={handleFormDataChange}
                                            onBlur={handleValidation}
                                            valstate={!formValidityData.payFullAmountError}
                                            valMsg={formValidityData.payFullAmountErrMsg} />
                                    </td>
                                    <td style={{ borderStyle: 'none' }}><br /><label><nobr>Pay Bill Amount</nobr></label></td>
                                </tr>
                            </tbody></Table>
                        </Col>}
                    </Row >
                    {formData?.accountType?.accountType && formData.accountType.accountType !== 'DONATION' && !formData.payFullAmount && <Row>
                        <Col sm={6} md={4} lg={4}>
                            <FormField name="billPaymentAmount" type="text" label="Bill Amount" readOnly={formData.readOnly}
                                onChange={handleFormDataChange} onBlur={handleValidation} value={formData.billPaymentAmount}
                                valstate={!formValidityData.billPaymentAmountError} valMsg={formValidityData.billPaymentAmountErrMsg} />
                        </Col>
                    </Row>}
                </React.Fragment>}
                {formData?.accountType && formData.accountType.accountType === 'DONATION' && <Row>
                        {mediaType && <Col className="d-flex justify-content-start" md={4} lg={4} sm={12}>
                            <Image src={process.env.REACT_APP_BASE_API_URL + BUSINESS_DONATION_CAUSES_URL + '/' + formData.currentDonationCause + '/img'} fluid />
                        </Col>}
                        <Col sm={12} md={4} lg={4}>
                            <Row>
                                <Col>
                                    <FormField name="currentDonationCause" label="Select Cause" type="select" readOnly={formData.editMode || formData.readOnly || formData.sponsorshipCause}
                                        onChange={handleDonationCauseChange} onBlur={handleValidation} value={formData.currentDonationCause}
                                        valstate={!formValidityData.currentDonationCauseError} valMsg={formValidityData.currentDonationCauseErrMsg}>
                                        <option value="" key="zeroval"></option>
                                        {formData.donationLineItems.map((donationLineItem, idx) => (
                                            <option value={donationLineItem.causeId} key={idx}>{donationLineItem.lineItemDescription}</option>
                                        ))}
                                    </FormField>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormField name="currentDonationCauseValue" type="text" label="Donation Amount" readOnly={formData.readOnly || formData.sponsorshipCause}
                                        onChange={handleFormDataChange} onBlur={handleValidation} value={formData.currentDonationCauseValue}
                                        valstate={!formValidityData.currentDonationCauseValueError} valMsg={formValidityData.currentDonationCauseValueErrMsg}
                                        rref={causeAmountFieldRef} />
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    {selectedCauseAttributes && !hasDescription && <>
                                        {selectedCauseAttributes.map((causeAttr, idx) => {
                                            let donAmount = parseFloat(causeAttr.suggestedAmount) / 100;
                                            return (<React.Fragment key={idx}>
                                                <Button variant='secondary' className='mt-1 p-2 btn-fill' onClick={event => fillAmount(event, donAmount)}>
                                                    {formatCurrency(donAmount, businessConfig.locale, businessConfig.currency)}
                                                </Button>
                                                &nbsp;</React.Fragment>);
                                        })}

                                        {(selectedCauseAttributes && selectedCauseAttributes.length > 1)
                                            && <Button variant='secondary' className='mt-1 p-2 btn-fill' onClick={event => fillAmount(event, "0.00")} key="custamount">Custom Amount</Button>}
                                    </>}
                                    {selectedCauseAttributes && hasDescription &&
                                        <Row>
                                            {selectedCauseAttributes.map((causeAttr, idx) => {
                                                let donAmount = parseFloat(causeAttr.suggestedAmount) / 100;
                                                return (<React.Fragment key={idx}>
                                                    <Col sm={12} md={12} lg={12}>
                                                        <Button variant='secondary' className='mt-2 p-2 btn-fill flex-fill w-100' onClick={event => fillAmount(event, donAmount, causeAttr.description)}>
                                                            {formatCurrency(donAmount, businessConfig.locale, businessConfig.currency)} - {causeAttr.description.toUpperCase()}
                                                        </Button>
                                                    </Col>

                                                </React.Fragment>);
                                            })}
                                            {(selectedCauseAttributes && selectedCauseAttributes.length > 1)
                                                && <Col sm={12} md={12} lg={12}>
                                                    <Button variant='secondary' className='mt-2 p-2 btn-fill flex-fill w-100' onClick={event => fillAmount(event, "0.00")} key="custamount">Custom Amount</Button>
                                                </Col>}
                                        </Row>}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col mb={6} lg={6} sm={12}>
                        <FormField
                            name="nextPaymentDate"
                            label="Next Payment Date"
                            type="date"
                            readOnly={formData.readOnly}
                            value={formData.nextPaymentDate}
                            placeholder="Enter Next Payment Date"
                            onChange={handleFormDataChange}
                            onBlur={handleValidation}
                            valstate={!formValidityData.nextPaymentDateError} valMsg={formValidityData.nextPaymentDateErrMsg} />
                    </Col>
                    <Col mb={6} lg={6} sm={12}>
                        <FormField name="paymentFreq" label="Payment Frequency" type="select"
                            placeholder="Payment Frequency" onChange={handleFormDataChange} onBlur={handleFormDataChange}
                            valstate={!formValidityData.paymentFreqError} valMsg={formValidityData.paymentFreqErrMsg}
                            readOnly={formData.readOnly || formData.sponsorshipCause} value={formData.paymentFreq || "MONTHLY"}>
                            <option value="">Select Payment Frequency</option>
                            <option value="DAILY">Daily</option>
                            <option value="WEEKLY">Weekly</option>
                            <option value="BIWEEKLY">Bi-Weekly</option>
                            <option value="MONTHLY">Monthly</option>
                            <option value="QUARTERLY">Quarterly</option>
                            <option value="SEMIANNUALLY">Semi-Anuallyy</option>
                            <option value="ANNUALLY">Annually</option>
                        </FormField>
                    </Col>
                </Row>
                <Row><Col>&nbsp;</Col></Row>
                <Row>
                    <Col>
                        <Table><tbody>
                            <tr><td className="mt-4 p-0" style={{ borderStyle: 'none' }} colSpan="2">
                                If you would like to have the receipt for the recurring payments in the name of your organization,
                                update the "Company Name" field in the User Profile and select this checkbox.
                            </td></tr>
                            <tr>
                                <td className="m-0 p-0" style={{ borderStyle: 'none' }} width="35px">
                                    <br /><FormField
                                        name="receiptInCompanyName"
                                        type="checkbox"
                                        checktype="checkbox"
                                        disabled={formData.readOnly || _.isEmpty(formData.companyName)}
                                        value={formData.receiptInCompanyName}
                                        checked={formData.receiptInCompanyName}
                                        onChange={handleFormDataChange}
                                        onBlur={handleValidation}
                                        valstate={!formValidityData.receiptInCompanyNameError}
                                        valMsg={formValidityData.receiptInCompanyNameErrMsg} />
                                </td>
                                <td className="m-0 p-0" style={{ borderStyle: 'none' }}>
                                    <br /><label><nobr>Receipt In Company Name <FontAwesomeIcon icon={faInfoCircle} title="may be disabled due to absence of Company Name in user profile" /></nobr></label>
                                </td>
                            </tr>
                        </tbody></Table>
                    </Col>
                </Row>
                <Row>
                    <Col><br /><h6>User Profile Summary</h6>
                        These fields can be modified in the user profile screen.
                    </Col>
                </Row>
                <Row>
                    <Col mb={6} lg={6} sm={12}>
                        <FormField name="email" label="Email" type="text" value={formData.email}
                            placeholder="Email" onChange={handleFormDataChange} onBlur={handleEmailValidation}
                            valstate={!formValidityData.emailError} valMsg={formValidityData.emailErrMsg}
                            readOnly={!secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")} />
                    </Col>

                    <Col mb={6} lg={6} sm={12}>
                        <FormField name="mobilePhoneNumber" label="Mobile Phone Number" type="text" value={formData.mobilePhoneNumber}
                            placeholder="Mobile Phone Number" onChange={handleFormDataChange} onBlur={handleValidation}
                            valstate={!formValidityData.mobilePhoneNumberError} valMsg={formValidityData.mobilePhoneNumberErrMsg}
                            readOnly={true} />
                    </Col>
                </Row>
                <Row>
                    <Col mb={6} lg={6} sm={12}>
                        <FormField name="companyName" label="Company Name" type="text" value={formData.companyName}
                            placeholder="Company Name" onChange={handleFormDataChange} onBlur={handleValidation}
                            valstate={!formValidityData.companyNameError} valMsg={formValidityData.companyNameErrMsg}
                            readOnly={true} />
                    </Col>
                </Row>
                {!_.isEmpty(formData.paymentCards) && (formData.paymentCards.length > 0) &&
                    <><Row>
                        <Col><br /><h6>Payment Cards</h6><br /></Col>
                    </Row>
                        <Row>
                            <Col mb={6} lg={6} sm={12}>

                                <FormField name="paymentCardId" label="Payment Cards" type="select"
                                    placeholder="Payment Cards" onChange={handleFormDataChange} onBlur={handleValidation}
                                    valstate={!formValidityData.paymentCardIdError} valMsg={formValidityData.paymentCardIdErrMsg}
                                    readOnly={formData.readOnly} value={formData.paymentCardId}>
                                    <option value="" key="noval">Select Payment Card</option>
                                    {formData.paymentCards.map((paymentCard, idx) => (
                                        <option value={paymentCard.paymentCardId} key={idx}>{paymentCard.maskedAccountNumber}</option>

                                    ))}
                                </FormField>
                                <small><strong>if not selected, you will be able to enter payment card details manually when you click the "Update Card and Save One Recurring Payment" button</strong></small>

                            </Col>

                        </Row></>}

                {_.isEmpty(formData.paymentCardId) && <>
                    <Row>
                        <Col>
                            <br /><h6>Payment Card Address Verification</h6><br />
                        </Col>
                    </Row>
                    <Row>
                        <Col mb={6} lg={6} sm={12}>
                            <FormField name="firstName" label="First Name" type="text" value={formData.firstName}
                                placeholder="First Name" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.firstNameError} valMsg={formValidityData.firstNameErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>
                        <Col mb={6} lg={6} sm={12}>
                            <FormField name="lastName" label="Last Name" type="text" value={formData.lastName}
                                placeholder="Last Name" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.lastNameError} valMsg={formValidityData.lastNameErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>
                    </Row>
                    <Row>
                        <Col mb={12} lg={12} sm={12}>
                            <FormField name="address" label="Address" type="text" value={formData.address}
                                placeholder="Address" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.addressError} valMsg={formValidityData.addressErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>
                    </Row>
                    <Row>
                        <Col mb={2} lg={2} sm={6}>
                            <CountrySelect name="country" onChange={handleCountryChange} onBlur={handleValidation}
                                valstate={!formValidityData.countryError} valMsg={formValidityData.countryErrMsg}
                                readOnly={formData.readOnly} value={formData.country} />
                        </Col>
                        <Col mb={4} lg={4} sm={6}>
                            <ProvinceSelect name="state" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.stateError} valMsg={formValidityData.stateErrMsg}
                                readOnly={formData.readOnly} value={formData.state} country={formData.country} />
                        </Col>
                    </Row>
                    <Row>
                        <Col mb={5} lg={5} sm={12}>
                            <FormField name="city" label="City" type="text" value={formData.city}
                                placeholder="City" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.cityError} valMsg={formValidityData.cityErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>

                        <Col mb={4} lg={4} sm={6}>
                            <PostalCode name="zip" label="Postal Code" type="text" value={formData.zip}
                                placeholder="Postal Code" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.zipError} valMsg={formValidityData.zipErrMsg}
                                readOnly={formData.readOnly} country={formData.country} />
                        </Col>
                    </Row>
                </>}


                <Row><Col>
                    <Table>
                        <tbody>
                            <tr>
                                {businessConfig.businessFee.feePayer === 'CUSTOMER_OPTIONAL' && <td style={{ paddingLeft: 0 }}>
                                    <FormField
                                        type="checkbox"
                                        name="customerConsentsToPayPfFees"
                                        value={formData.customerConsentsToPayPfFees || false}
                                        checked={formData.customerConsentsToPayPfFees || false}
                                        onChange={handleFormDataChange}
                                    />
                                </td>}
                                <td>
                                    {
                                        businessConfig.businessFee.feePayer === 'CUSTOMER_OPTIONAL' &&
                                        <>Payer agrees to pay for the transaction cost of:
                                            <b>{businessConfig.businessFee.feeType === 'FIXED'
                                                ? formatCurrency(parseFloat(businessConfig.businessFee.fee / 100), businessConfig.locale, businessConfig.currency)
                                                : businessConfig.businessFee.fee + "%"}</b></>
                                    }
                                    {
                                        businessConfig.businessFee.feePayer === 'CUSTOMER_MANDATORY' &&
                                        <>Payer is required to cover the transaction cost of:
                                            <b>{businessConfig.businessFee.feeType === 'FIXED'
                                                ? formatCurrency(parseFloat(businessConfig.businessFee.fee / 100), businessConfig.locale, businessConfig.currency)
                                                : businessConfig.businessFee.fee + "%"}</b></>
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col></Row>
                {!formData.pmtResult && _.isEmpty(formData.paymentCardId) && formData?.zip && paymentGateway && paymentGateway === 'STRIPE' && <>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row>
                        <Col>
                            <StripeElements formData={formData} saveCardFunction={saveCardFunction} handlePaymentResult={handlePaymentResult} />
                        </Col>
                    </Row>
                </>}

                {!formData.pmtResult &&
                    <Row><Col>
                        <div>This will save the card information and schedules recurring payments to be made on the date selected.
                            When you click the button below, it only saves the payment information but <b>does NOT make any payment</b> at this time.</div>
                        <br />
                        <SubmitButton label={(formData.editMode ? 'Update' : 'Add') + ' Card Information and Save Schedule'} disabled={formData.readOnly} className="me-4" />
                        <CancelButton label='Return to List Page' onClick={handleCancel} />
                    </Col>
                    </Row>
                }
            </FormContainer >
        </>
    )
}

export default RecurringPaymentPage